import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IDetailDocument } from '@shared/components/modal/modal.interface';

@Injectable({
  providedIn: 'root',
})
export class PdfService {
  constructor(private http: HttpClient) {}

  getPdf(url: string): Observable<Blob> {
    // Set the response type to 'blob' to handle binary data
    return this.http.get(url, { responseType: 'blob' });
  }

  downloadPdf(item: IDetailDocument) {
    return this.getPdf(item.url).pipe(
      map((res) => {
        const blob = new Blob([res], { type: 'application/pdf' });

        // Create a link element and trigger the download
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = item.name ? item.name : 'downloaded.pdf';
        link.click();

        // Clean up
        window.URL.revokeObjectURL(link.href);
        return blob;
      })
    );
  }

  downloadPdfBase64(base64String: string, fileName: string): void {
    // Remove data URI prefix if present
    const base64Data = base64String.includes(',') ? base64String.split(',')[1] : base64String;

    // Decode base64 to binary
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Uint8Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    // Create blob and trigger download
    const blob = new Blob([byteNumbers], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);

    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = fileName;
    anchor.click();

    // Cleanup
    URL.revokeObjectURL(url);
  }

  downloadBlob(resp: HttpResponse<Blob>, fileName: string) {
    const blob = resp.body;
    if (!blob) return;

    const contentType = resp.headers.get('Content-Type') || '';
    const extension = contentType.includes('spreadsheetml') || contentType.includes('excel') ? '.xlsx' : contentType.includes('zip') ? '.zip' : '.pdf';

    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName + extension;
    link.click();
    URL.revokeObjectURL(url);
  }
}
